import { GlobalExclusionsController } from '../controller/GlobalExclusionsController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { ExclusionListItem } from '../../exclusionsApp/types';

export class GlobalExclusionsWebComponent extends BaseWebComponentElement {

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GlobalExclusionsController,
    });
  }

  set activeExclusionList(value: ExclusionListItem | undefined) {
    if (!value) {
      return;
    }
    this.setAttribute('data-active-exclusion-list', JSON.stringify(value));
  }

  get activeExclusionList(): ExclusionListItem | undefined {
    const value = this.getAttribute('data-active-exclusion-list');
    return value ? JSON.parse(value) : undefined;
  }

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, "data-active-exclusion-list"];
  }

  override attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (GlobalExclusionsWebComponent.observedAttributes.indexOf(name) !== -1) {
      (this.controller as GlobalExclusionsController)?.render().then().catch();
    }
  }

}
